<template>
  <div :id="`chart${id}`" style="width: 100%"></div>
</template>

<script>

import ApexCharts from 'apexcharts'

export default {
  props: ['chartdata'],

  computed: {
    options () {
      return {
        chart: {
          type: 'donut'
        },
        series: this.chartdata.series,
        labels: this.chartdata.labels
      }
    },
  },

  data() {
    return {
      id: Math.floor(Math.random(999) * 100) + Math.floor(Math.random(999) * 100)
    }
  },

  mounted () {
    let chart = new ApexCharts(document.querySelector(`#chart${this.id}`), this.options);

    chart.render();
  }
}
</script>

<style>
</style>